import { render, staticRenderFns } from "./SchoolFacialUserModal.vue?vue&type=template&id=b2ac653e&scoped=true&"
import script from "./SchoolFacialUserModal.vue?vue&type=script&lang=js&"
export * from "./SchoolFacialUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ac653e",
  null
  
)

export default component.exports